var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 168,
    viewBox: "0 0 199 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vi with stroke and shadow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape",
    filter: "url(#filter0_bd_3052_707905)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 68.5C31 106.331 61.6685 137 99.5 137C137.332 137 168 106.331 168 68.5C168 68.3435 167.999 68.1872 167.998 68.031V68.5H31Z",
    fill: "white",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    filter: "url(#filter1_b_3052_707905)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 68.5,
    r: 68.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/vi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/vi_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6002 129.195C133.062 129.195 160.189 102.067 160.189 68.6033C160.189 35.1395 133.062 8.01172 99.6002 8.01172C66.138 8.01172 39.0117 35.1395 39.0117 68.6033C39.0117 102.067 66.138 129.195 99.6002 129.195Z",
    fill: "#20662E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5014 89.1194L131.719 51.1909C132.82 50.2022 132.827 48.5927 131.735 47.5959L129.758 45.7908C128.666 44.794 126.889 44.7878 125.789 45.7765L87.5564 80.1241L71.4217 65.3933C70.33 64.3966 68.5525 64.3901 67.4519 65.3789L65.459 67.1693C64.3584 68.158 64.3513 69.7676 65.4431 70.7643L85.5316 89.1049C86.6233 90.1017 88.4007 90.1081 89.5014 89.1194Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_3052_707905",
    x: 0,
    y: 37.031,
    width: 199,
    height: 130.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 9.29652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3052_707905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.4 0 0 0 0 0.180392 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_3052_707905",
    result: "effect2_dropShadow_3052_707905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3052_707905",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3052_707905",
    x: 12.407,
    y: -18.593,
    width: 174.186,
    height: 174.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 9.29652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3052_707905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3052_707905",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/Vi.f2ed1115cda5ee6983a052d9f82e4f99.svg";
export { ForwardRef as ReactComponent };